module.exports = __webpack_public_path__ + "static/Thumb_NC1_NightCity_comp-e0db2bd8909c6b91fb075b843fa08ebe.png";